import {
  ValidatedCoupon,
  validatedCouponFromResponse,
} from '../interfaces/Coupon/ValidatedCoupon';
import api, { apiPrefix } from './Api';

export const getValidatedCoupon = async (
  code: string,
): Promise<ValidatedCoupon> => {
  const response = await api.post(`${apiPrefix}/couponExists`, {
    code,
  });

  return validatedCouponFromResponse(response.data);
};
